import {Component, OnInit} from '@angular/core';
import {DynamicBarService} from "../_components/dynamic-bar/dynamic-bar.service";



@Component({
    selector: 'home-barra',
    standalone: false,
    template: `
        <div class="header-mainInfo">
            <h1 class="">Inicio</h1>
            <span class="spacer"></span>
        </div>`
})

export class HomeBarraComponent implements OnInit {
    constructor(private dynamicBarService: DynamicBarService) {
    }

    ngOnInit() {
    }
}
